import { useEffect, useState } from 'react';
import { Megaphone } from 'lucide-react';
import { Prize } from '../../services/prizes';
import { attendeeDisplayName } from '../../utils/attendeeDisplayName';

interface ShoutoutOverlayProps {
  prize: Prize;
  onDismiss: () => void;
}

export default function ShoutoutOverlay({ prize, onDismiss }: ShoutoutOverlayProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    requestAnimationFrame(() => setVisible(true));
    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(onDismiss, 300);
    }, 10000);
    return () => clearTimeout(timer);
  }, [onDismiss]);

  const handleDismiss = () => {
    setVisible(false);
    setTimeout(onDismiss, 300);
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60"
      onClick={handleDismiss}
    >
      <div
        className={`max-w-md w-full rounded-2xl bg-gradient-to-br from-purple-600 to-indigo-700 p-6 text-center shadow-2xl transition-all duration-300 ${
          visible ? 'scale-100 opacity-100' : 'scale-75 opacity-0'
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="w-14 h-14 mx-auto rounded-full bg-white/20 flex items-center justify-center mb-4">
          <Megaphone className="w-7 h-7 text-white" />
        </div>

        <h2 className="text-2xl font-bold text-white mb-2">
          {prize.winnerNickname || (prize.winnerId ? attendeeDisplayName(null, prize.winnerId) : 'Someone special')}
        </h2>

        {prize.customText && (
          <p className="text-lg text-purple-100 mb-4">{prize.customText}</p>
        )}

        <button
          onClick={handleDismiss}
          className="mt-2 px-6 py-2 rounded-full bg-white/20 hover:bg-white/30 text-white text-sm font-medium transition-colors"
        >
          Tap to dismiss
        </button>
      </div>
    </div>
  );
}
